import React, { PropsWithChildren } from "react";
import {
  checkIsAgent,
  checkIsCD,
  checkIsFilmmakersProfile,
  checkIsPerformer,
} from "shared-auth";
import AgentAppShell from "../AgentAppShell";
import PerformerAppShell from "../PerformerAppShell";
import CdAppShell from "../CdAppShell";
import GenericAppShell, { GenericAppShellProps } from "../GenericAppShell";
import FilmmakersAppShell from "../FilmmakersAppShell";

const UniversalAppShell = ({
  footerComponent,
  hideFooter,
  serviceBannerPortalNone,
  children,
}: PropsWithChildren<
  Pick<
    GenericAppShellProps,
    "hideFooter" | "footerComponent" | "serviceBannerPortalNone"
  >
>) => {
  if (checkIsFilmmakersProfile())
    return (
      <FilmmakersAppShell
        hideFooter={hideFooter}
        footerComponent={footerComponent}
      >
        {children}
      </FilmmakersAppShell>
    );

  if (checkIsPerformer())
    return (
      <PerformerAppShell
        hideFooter={hideFooter}
        footerComponent={footerComponent}
        serviceBannerPortalNone={serviceBannerPortalNone}
      >
        {children}
      </PerformerAppShell>
    );

  if (checkIsAgent())
    return (
      <AgentAppShell hideFooter={hideFooter} footerComponent={footerComponent}>
        {children}
      </AgentAppShell>
    );

  if (checkIsCD())
    return (
      <CdAppShell hideFooter={hideFooter} footerComponent={footerComponent}>
        {children}
      </CdAppShell>
    );

  return (
    <GenericAppShell footerComponent={footerComponent} hideFooter={hideFooter}>
      {children}
    </GenericAppShell>
  );
};

export default UniversalAppShell;
